import React from "react";

// Admin Imports
import Dashboard from "views/admin/dashboard";
import UserManagement from "views/admin/user-management";
import ContactInquiries from "views/admin/contact-inquiries";
import FAQsManagement from "views/admin/faqs-management";
import CMSManagement from "views/admin/cms-management";
import FeaturesManagement from "views/admin/features-management";
import NewsManagement from "views/admin/news-management";
import ProfilePage from "views/admin/profile";

// Auth Imports
import SignIn from "views/auth/SignIn";
import ForgotPassword from "views/auth/ForgotPassword";
import ResetPassword from "views/auth/ResetPassword";

// Icon Imports
import {
  MdDashboard,
  MdPeople,
  MdContactMail,
  MdQuestionAnswer,
  MdWebAsset,
  MdLock,
  MdPerson,
  MdFlashOn,
  MdNewspaper,
} from "react-icons/md";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "dashboard",
    icon: <MdDashboard className="h-6 w-6" />,
    component: <Dashboard />,
  },
  {
    name: "User Management",
    layout: "/admin",
    path: "user-management",
    icon: <MdPeople className="h-6 w-6" />,
    component: <UserManagement />,
  },
  {
    name: "Contact Inquiries",
    layout: "/admin",
    path: "contact-inquiries",
    icon: <MdContactMail className="h-6 w-6" />,
    component: <ContactInquiries />,
  },
  {
    name: "FAQs Management",
    layout: "/admin",
    path: "faqs-management",
    icon: <MdQuestionAnswer className="h-6 w-6" />,
    component: <FAQsManagement />,
  },
  {
    name: "CMS Management",
    layout: "/admin",
    path: "cms-management",
    icon: <MdWebAsset className="h-6 w-6" />,
    component: <CMSManagement />,
  },
  {
    name: "Features",
    layout: "/admin",
    path: "features-management",
    icon: <MdFlashOn className="h-6 w-6" />,
    component: <FeaturesManagement />,
  },
  {
    name: "News",
    layout: "/admin",
    path: "news-management",
    icon: <MdNewspaper className="h-6 w-6" />,
    component: <NewsManagement />,
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    icon: <MdPerson className="h-6 w-6" />,
    component: <ProfilePage />,
    hidden: true,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Forgot Password",
    layout: "/auth",
    path: "forgot-password",
    icon: <MdLock className="h-6 w-6" />,
    component: <ForgotPassword />,
  },
  {
    name: "Reset Password",
    layout: "/auth",
    path: "reset-password/:token",
    icon: <MdLock className="h-6 w-6" />,
    component: <ResetPassword />,
  },
];

export default routes;
